/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JsonFindPartyResponse,
    JsonFindPartyResponseFromJSON,
    JsonFindPartyResponseFromJSONTyped,
    JsonFindPartyResponseToJSON,
} from './JsonFindPartyResponse';

/**
 * 
 * @export
 * @interface ApiResultOfListOfJsonFindPartyResponse
 */
export interface ApiResultOfListOfJsonFindPartyResponse {
    /**
     * 
     * @type {Array<JsonFindPartyResponse>}
     * @memberof ApiResultOfListOfJsonFindPartyResponse
     */
    data?: Array<JsonFindPartyResponse>;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfListOfJsonFindPartyResponse
     */
    message?: string;
    /**
     * 
     * @type {object}
     * @memberof ApiResultOfListOfJsonFindPartyResponse
     */
    messageValues?: object;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfListOfJsonFindPartyResponse
     */
    requestId?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfListOfJsonFindPartyResponse
     */
    result?: ApiResultOfListOfJsonFindPartyResponseResultEnum;
}

/**
* @export
* @enum {string}
*/
export enum ApiResultOfListOfJsonFindPartyResponseResultEnum {
    Ok = 'OK',
    Error = 'ERROR'
}

export function ApiResultOfListOfJsonFindPartyResponseFromJSON(json: any): ApiResultOfListOfJsonFindPartyResponse {
    return ApiResultOfListOfJsonFindPartyResponseFromJSONTyped(json, false);
}

export function ApiResultOfListOfJsonFindPartyResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResultOfListOfJsonFindPartyResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(JsonFindPartyResponseFromJSON)),
        'message': !exists(json, 'message') ? undefined : json['message'],
        'messageValues': !exists(json, 'messageValues') ? undefined : json['messageValues'],
        'requestId': !exists(json, 'requestId') ? undefined : json['requestId'],
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function ApiResultOfListOfJsonFindPartyResponseToJSON(value?: ApiResultOfListOfJsonFindPartyResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(JsonFindPartyResponseToJSON)),
        'message': value.message,
        'messageValues': value.messageValues,
        'requestId': value.requestId,
        'result': value.result,
    };
}

